import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, List, Segment, Menu, MenuItem, Icon, Sticky, Label, Popup } from "semantic-ui-react";
import ReactTable from "react-table";
import { loc } from "../../utils/constants";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import matchSorter from 'match-sorter';

export const columns = [
  {
    accessor: d => (
      <div>
        <Button as={Link} to={`/events/${d.id}/summary`} icon="line graph" secondary={!d.is_active} color={d.is_active && "green"} />
        <Button as={Link} to={`/events/${d.id}/edit`} icon="edit" primary />
      </div>
    ),
    id: "id",
    Header: "ID",
    filterable: false,
    width: 125
  },
  {
    accessor: "title",
    Header: "Title",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["title"] }),
    filterAll: true
  },
  {
    accessor: "start_at",
    Header: "Start Date",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["start_at"] }),
    filterAll: true
  },
  {
    accessor: "end_at",
    Header: "End Date",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["end_at"] }),
    filterAll: true
  },
  {
    accessor: d => {
      const jackpot = d.jackpot !== null ? d.jackpot : 0;
      return (
        <List>
          <List.Item>
            <List.Content>
              <List.Description>{d.game_id !== 1 ? `` : `$${jackpot}`}</List.Description>
            </List.Content>
          </List.Item>
        </List>
      )
    },
    id: "5050jackpot",
    Header: "50/50 Jackpot",
    filterable: false
  },
  {
    accessor: d => {
      const thread_is_final = d.thread_is_final === 1 ? true : false;
      const winningnumber = d.number === null ? true : false;
      const jackpot = d.jackpot !== null ? d.jackpot : 0;
      return (
        <List>
          {d.game_id === 3 && thread_is_final && (
            <List.Item>
              <List.Content>
                <List.Description color='green'>${jackpot} WON!</List.Description>
              </List.Content>
            </List.Item>
          )}
          {d.game_id === 3 && !thread_is_final && winningnumber && (
            <List.Item>
              <List.Content>
                <List.Description >${d.jackpot}</List.Description>
              </List.Content>
            </List.Item>
          )}
          {d.game_id === 3 && !thread_is_final && !winningnumber && (
            <List.Item>
              <List.Content>
                <List.Description color='red'>${d.jackpot} CARRYOVER</List.Description>
              </List.Content>
            </List.Item>
          )}
          {d.game_id !== 3 && (
            <List.Item>
            <List.Content>
              <List.Description></List.Description>
            </List.Content>
          </List.Item>
          )}
        </List>
      );
    },
    id: "ctajackpot",
    Header: "CTA Jackpot",
    filterable: false
  },
  {
    accessor: d => {
      const prize = d.prize !== null ? d.prize : 0;
      return (
        <List>
          <List.Item>
            <List.Content>
              <List.Description>{d.game_id !== 3 ? `` : `$${prize}`}</List.Description>
            </List.Content>
          </List.Item>
        </List>
      )
    },
    id: "weeklyPrize",
    Header: "Weekly Prize",
    filterable: false
  },
  {
    accessor: "nonprofit.name",
    id: "nonprofit_id",
    Header: "Non Profit",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["nonprofit_id"] }),
    filterAll: true
  },
  {
    accessor: d => {
      const websales = d.webenabled === 1 ? true : false;
      const testevent = d.is_test === 1 ? true : false;
      const shopifyEnabled = d.shopify_enabled === 1 ? true: false;
      return (
        <List>
          {testevent && (
            <List.Item>
              <List.Icon size="large" name="hide" color="grey" />
              <List.Content>
                <List.Header>Test Event</List.Header>
              </List.Content>
            </List.Item>
          )}
          {d.active_rsu_event > 0 &&
            <List.Item>
              <List.Icon size="large" name="tablet" color="green" />
              <List.Content>
                <List.Header>Active RSU Event</List.Header>
              </List.Content>
            </List.Item>
          }
          {websales && !shopifyEnabled && (
            <List.Item as="a" onClick={() => window.open(d.weburl)}>
              <List.Icon size="large" name="globe" color="green" />
              <List.Content>
                <List.Header>E-Commerce</List.Header>
                <List.Description>Click to view</List.Description>
              </List.Content>
            </List.Item>
          )}
          {!websales && shopifyEnabled && (
            <List.Item as="a" onClick={() => window.open(d.shopify_storefront)}>
              <List.Icon size="large" name="globe" color="green" />
              <List.Content>
                <List.Header>Shopify Storefront</List.Header>
                <List.Description>Click to view</List.Description>
              </List.Content>
            </List.Item>
          )}
          {d.jackpot_id > 0 && (
            <List.Item as="a" onClick={() => window.open(`${loc.origin}/jackpot?eventId=${d.id}&jackpotId=${d.jackpot_id}`)}>
              <List.Icon size="large" name="tv" color="green" />
              <List.Content>
                <List.Header>Jackpot Screen</List.Header>
                <List.Description>Click to view</List.Description>
              </List.Content>
            </List.Item>
          )}
        </List>
      );
    },
    id: "webenabled",
    Header: "Details",
    filterable: false,
    width: 175
  }
];

const eventTabs = {
  activeDraws: 1,
  completedDraws: 2,
  archivedDraws: 3
}

class EventList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: [],
      total: 0,
      activeItem: eventTabs.activeDraws
    };
  }
  componentDidMount = () => {
    this.fetchData();
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/event", {
        sort: [],
        q: "",
        page: 1,
        limit: 0,
        filterDraws: this.state.activeItem
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: resp.last_page
        });
      });
  };
  handleDrawsMenuClick = (e, activeTab) => {
    this.setState({ activeItem: activeTab }, () => {
      this.fetchData();
    })
  }
  render() {
    const { data, isLoading, activeItem } = this.state;
    let settings = this.context && this.context.settings ? this.context.settings : {};
    return (
      <Segment basic loading={isLoading} className="eventListSegment">
        <Menu secondary stackable>
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/events/create"}
                icon="line graph"
                content="New event"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        {settings &&
          (+settings.hidden.dynamic_pricing_enabled > 0 ||
            +settings.hidden.pricepoint_labels_enabled > 0 ||
            +settings.hidden.pricepoint_limits_enabled > 0 ||
            +settings.hidden.custom_web_pricing_enabled > 0 ||
            +settings.hidden.sequential_numbers_enabled > 0 ||
            +settings.web.allow_freeticket > 0 ||
            +settings.web.giftingOption > 0 ||
            +settings.web.employee_raffle_on_off > 0) &&
          <Menu secondary stackable>
            <Menu.Menu position='right'>
              <Menu.Item>
                <Label.Group>
                <Popup
                  trigger={<Icon name='help' color='blue' size='small' circular />}
                  content="These features are currently enabled. Go to settings page to disable any or all of these."
                  basic
                />
                  {+settings.hidden.dynamic_pricing_enabled > 0 && <Label basic color='green'>Dynamic Pricing</Label>}
                  {+settings.hidden.pricepoint_labels_enabled > 0 && <Label basic color='green'>Pricepoint Labels</Label>}
                  {+settings.hidden.pricepoint_limits_enabled > 0 && <Label basic color='green'>Pricepoint Limits</Label>}
                  {+settings.hidden.custom_web_pricing_enabled > 0 && <Label basic color='green'>Custom Web Prices</Label>}
                  {+settings.hidden.sequential_numbers_enabled > 0 && <Label basic color='green'>Sequential Numbers</Label>}
                  {+settings.web.allow_freeticket > 0 && <Label basic color='green'>Free Tickets</Label>}
                  {+settings.web.giftingOption > 0 && <Label basic color='green'>Gift Tickets</Label>}
                  {+settings.web.employee_raffle_on_off > 0 && <Label basic color='green'>Employee Raffle</Label>}
                </Label.Group>
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        }
        <Sticky>
          <Menu color='orange' pointing stackable>
            <MenuItem name="activeDraws" active={activeItem === eventTabs.activeDraws} onClick={(e) => { this.handleDrawsMenuClick(e, eventTabs.activeDraws) }}>
              <Icon name='calendar check' color='green' />
              Active Draws
          </MenuItem>
            <MenuItem name="completedDraws" active={activeItem === eventTabs.completedDraws} onClick={(e) => { this.handleDrawsMenuClick(e, eventTabs.completedDraws) }}>
              <Icon name='flag checkered' />
              Completed Draws
          </MenuItem>
            <MenuItem name="archivedDraws" active={activeItem === eventTabs.archivedDraws} onClick={(e) => { this.handleDrawsMenuClick(e, eventTabs.archivedDraws) }}>
              <Icon color='red' name='archive' />
              Archived Draws
          </MenuItem>

          </Menu>
        </Sticky>
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          filterable
          defaultPageSize={20}
          defaultSorted={[{ id: "start_at", desc: true }]}
          minRows={0}
        />
      </Segment>
    );
  }
}
EventList.contextType = AppContext;

export default EventList;
